import { render, staticRenderFns } from "./APIRefView.vue?vue&type=template&id=e389c734&scoped=true&"
import script from "./APIRefView.vue?vue&type=script&lang=js&"
export * from "./APIRefView.vue?vue&type=script&lang=js&"
import style0 from "./APIRefView.vue?vue&type=style&index=0&id=e389c734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e389c734",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VDivider,VSimpleTable})
